// External libraries
import React, { useEffect } from 'react';

// Internal modules
import { features, logger } from '@/lib';
import { Streamline } from '../Streamline';
import { weasleyFlowType } from '../constants';
import { ContactFieldsSection } from '@/components/ContactInformation';
import { PasswordlessForcedSignupSubmission } from '../../../FormSubmission';

export const ForcedPasswordless = (): JSX.Element => {
  const isStreamlineExperience = features.isActive(
    'isStreamlineForcedExperience',
  );

  useEffect(() => {
    logger.info(
      isStreamlineExperience
        ? 'rendering_streamline_passwordless_forced_sign_up_flow'
        : 'rendering_passwordless_forced_sign_up_flow',
    );
  }, []);

  if (isStreamlineExperience) {
    return <Streamline flowType={weasleyFlowType.FORCED_PASSWORDLESS_FLOW} />;
  }

  return (
    <>
      <ContactFieldsSection mb="gutter" />
      <PasswordlessForcedSignupSubmission />
    </>
  );
};
